import { createContext, useState, useContext, useEffect } from 'react';
import { authService } from '../services/authService';
import { apiService } from '../services/apiService';
import config from '../config';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
	const [user, setUser] = useState(null);
	const [loading, setLoading] = useState(true);

	useEffect(() => {
		checkAuth();
	}, []);

	const checkAuth = async () => {
		try {
			if (authService.isAuthenticated()) {
				try {
					const userData = await apiService.get('/user');
					setUser(userData);
				} catch (error) {
					if (error.message === 'Unauthorized') {
						const refreshData = await apiService.post('/refresh');
						authService.setToken(refreshData.token);
						console.log('aaaaaaaaaaaa');
						setUser(refreshData.user);
					}
				}
			}
		} catch (error) {
			console.error('Authentication check failed:', error);
			authService.removeToken();
			setUser(null);
			window.location.href = '/login';
		} finally {
			setLoading(false);
		}
	};

	const login = async (email, password) => {
		try {
			const response = await fetch(`${config.API_BASE_URL}/login`, {
				method: 'POST',
				headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json',
				},
				body: JSON.stringify({ email, password }),
			});

			if (!response.ok) {
				let errorMessage = 'Login failed';
				try {
					const errorData = await response.json();
					errorMessage =
						errorData?.errors?.email?.[0] ||
						errorData?.message ||
						errorMessage;
				} catch (_) {
					// Keep a generic message when response body is not JSON.
				}
				throw new Error(errorMessage);
			}

			const data = await response.json();

			// Store the token
			if (data.token) {
				authService.setToken(data.token);
			}

			// Set user data
			setUser(data.user);
			return true;
		} catch (error) {
			console.error('Login error:', error);
			throw error;
		}
	};

	const logout = async () => {
		try {
			await apiService.post('/logout');
			authService.removeToken();
			setUser(null);
		} catch (error) {
			console.error('Logout error:', error);
			// Even if the logout request fails, we'll clear the local state
			authService.removeToken();
			setUser(null);
		}
	};

	return (
		<AuthContext.Provider value={{
			user,
			loading,
			login,
			logout,
			isAuthenticated: authService.isAuthenticated
		}}>
			{children}
		</AuthContext.Provider>
	);
};

export const useAuth = () => {
	const context = useContext(AuthContext);
	if (!context) {
		throw new Error('useAuth must be used within an AuthProvider');
	}
	return context;
};